import React from 'react'

export default function PlanCard({ plano, limite, preco, descricao, popular, selected, onClick }) {
  return (
    <div
      onClick={onClick}
      className={`plan-card ${selected ? 'selected' : ''} ${popular ? 'popular' : ''}`}
    >
      {popular && (
        <div className="plan-card-tag">
          Mais popular
        </div>
      )}
      <h3 className="plan-card-title">
        {plano}
      </h3>
      <p className="plan-card-price">
        {preco}
      </p>
      <p className="plan-card-desc">
        {descricao && <span>{descricao} • </span>}
        {limite} mensagens/mês
      </p>
      {selected && (
        <div className="plan-card-selected-text">
          ✓ Plano selecionado
        </div>
      )}
    </div>
  )
}
